import React from 'react';
import { ICategory } from '../../../types/ICategory';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { InvisiblyDefinedTerm } from '../InvisiblyDefinedTerm';

type CategoryLabelProps = {
  categories?: ICategory[];
  className?: string;
};

export function CategoryLabel({ categories, className }: CategoryLabelProps) {
  const { t } = useSonTranslation('glossary');
  if (!categories || categories.length === 0) {
    return null;
  }
  return (
    <InvisiblyDefinedTerm className={className} definition={t(`category${categories.length > 1 ? '_plural' : ''}`)}>
      {categories.map(category => category.title).join(', ')}
    </InvisiblyDefinedTerm>
  );
}
